import { QuestContentful } from 'models/QuestContentful';
import { baseService } from 'modules/baseService';
import HttpClient from 'services/HttpClient';
import { getLastUpdatedAtQuery } from 'helpers/helperFunctions';

export const getQuests = baseService<string | undefined, QuestContentful[]>(
  (lastUpdatedAt) =>
    HttpClient.get(`/contentful/quests${getLastUpdatedAtQuery(lastUpdatedAt)}`),
);
